import { jsxs as d, jsx as n, Fragment as b } from "react/jsx-runtime";
import { forwardRef as T, useState as k, useMemo as $, useRef as B, useImperativeHandle as G, useEffect as v, useCallback as h } from "react";
import { u as l } from "../../../../styled-components.browser.esm-BFmoFexH.js";
import { Input as K } from "antd";
import { IconContainer as x } from "@biron-data/react-components";
import { F as H } from "../../../../ExclamationIcon-ChUMLDqI.js";
import { _ as t, L as O, N as P } from "../../../../dummyModel-DGc8qBEQ.js";
import { l as V, f as W, c as A, h as D, o as I } from "../../../../utils-Mz58x57M.js";
import { useLanguageResolver as X } from "@biron-data/react-contexts";
const c1 = T(({
  filter: a,
  temporaryFilter: e,
  type: p,
  handleTemporaryFilterChange: m,
  handleFilterChange: u,
  onFocus: M,
  onBlur: L
}, R) => {
  const w = X(), [s, f] = k(V(e)), g = W(p), E = $(() => s === " " ? "" : s, [s]), [o, S] = k(E), i = A(p, o), j = D(o), C = B();
  G(
    R,
    () => ({
      focus() {
        C.current.focus();
      },
      blur() {
        C.current.blur();
      }
    }),
    []
  ), v(() => {
    i && S(a.predicate.operator === t.IN || V(a) === " " ? "" : V(a));
  }, [a]), v(() => {
    f(i ? o : "");
  }, [i, f, o]);
  const r = h((c, N) => ({
    ...c,
    predicate: {
      ...c.predicate,
      value: N
    },
    isValid: i
  }), [i]);
  v(() => {
    (e.predicate.operator === t.Like || e.predicate.operator === t.Match) && e.predicate.value.pattern !== g(I(s)) && m(r(e, {
      ...e.predicate.value,
      "@type": O.PATTERN,
      pattern: g(I(s))
    }));
  }, [e, m, s, g, p, i, r]);
  const z = h((c) => {
    S(c.target.value);
  }, []), Z = h(() => {
    e.predicate.operator === t.Like && u(r(e, {
      ...e.predicate.value,
      caseSensitive: !e.predicate.value.caseSensitive
    })), e.predicate.operator === t.Match && u(r(e, {
      ...e.predicate.value,
      caseSensitive: !e.predicate.value.caseSensitive
    }));
  }, [r, u, e]);
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ d(Q, { children: [
      /* @__PURE__ */ n(
        U,
        {
          ref: C,
          value: o,
          status: i ? void 0 : "error",
          onChange: z,
          onFocus: M,
          onBlur: () => L(),
          onKeyDown: (c) => {
            c.keyCode === 13 && L();
          }
        }
      ),
      /* @__PURE__ */ n(
        J,
        {
          $clicked: (e.predicate.operator === t.Like || e.predicate.operator === t.Match) && e.predicate.value.caseSensitive,
          onClick: Z,
          children: /* @__PURE__ */ n(x, { clickable: !0, titleKey: "filter.matchCase", children: /* @__PURE__ */ n("svg", { width: "19", height: "16", viewBox: "0 0 19 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ n(
            "path",
            {
              d: "M6.791 11.012H2.717L2.017 13H0.351L3.837 3.256H5.685L9.171 13H7.491L6.791 11.012ZM6.343 9.71L4.761 5.188L3.165 9.71H6.343ZM10.1547 9.108C10.1547 8.33333 10.3134 7.64733 10.6307 7.05C10.9574 6.45267 11.3961 5.99067 11.9467 5.664C12.5067 5.328 13.1227 5.16 13.7947 5.16C14.4014 5.16 14.9287 5.28133 15.3767 5.524C15.8341 5.75733 16.1981 6.05133 16.4687 6.406V5.286H18.0787V13H16.4687V11.852C16.1981 12.216 15.8294 12.5193 15.3627 12.762C14.8961 13.0047 14.3641 13.126 13.7667 13.126C13.1041 13.126 12.4974 12.958 11.9467 12.622C11.3961 12.2767 10.9574 11.8007 10.6307 11.194C10.3134 10.578 10.1547 9.88267 10.1547 9.108ZM16.4687 9.136C16.4687 8.604 16.3567 8.142 16.1327 7.75C15.9181 7.358 15.6334 7.05933 15.2787 6.854C14.9241 6.64867 14.5414 6.546 14.1307 6.546C13.7201 6.546 13.3374 6.64867 12.9827 6.854C12.6281 7.05 12.3387 7.344 12.1147 7.736C11.9001 8.11867 11.7927 8.576 11.7927 9.108C11.7927 9.64 11.9001 10.1067 12.1147 10.508C12.3387 10.9093 12.6281 11.2173 12.9827 11.432C13.3467 11.6373 13.7294 11.74 14.1307 11.74C14.5414 11.74 14.9241 11.6373 15.2787 11.432C15.6334 11.2267 15.9181 10.928 16.1327 10.536C16.3567 10.1347 16.4687 9.668 16.4687 9.136Z"
            }
          ) }) })
        }
      )
    ] }),
    j ? /* @__PURE__ */ d(_, { children: [
      /* @__PURE__ */ n(
        x,
        {
          size: 12,
          children: /* @__PURE__ */ n(H, {})
        }
      ),
      /* @__PURE__ */ n("span", { children: w.get("filter.spaceWarning") })
    ] }) : /* @__PURE__ */ n(b, {}),
    i ? /* @__PURE__ */ n(b, {}) : /* @__PURE__ */ d(q, { children: [
      /* @__PURE__ */ n(
        x,
        {
          size: 12,
          children: /* @__PURE__ */ n(H, {})
        }
      ),
      /* @__PURE__ */ n("span", { children: w.get(`filter.type.${P.REGEX}.warning`) })
    ] })
  ] });
}), _ = l.div`
  display: flex;
  color: var(--orange);
  font-size: 10px;
  align-content: center;
  align-items: center;
  gap: 4px;
`, q = l.div`
  display: flex;
  color: var(--target-red);
  font-size: 10px;
  align-content: center;
  align-items: center;
  gap: 4px;
`, J = l.span`
  display: flex;
  align-content: center;
  justify-content: end;
  align-items: center;

  svg {
      fill: ${({ $clicked: a }) => a ? "var(--primary)" : "var(--border-color-base)"}
  }

  &:hover {
    svg {
      fill: var(--primary-light);
    }
  }
`, Q = l.div`
  display: flex;
  gap: 6px;
`, U = l(K)`
  line-height: 28px;
  padding: 0 6px;
  box-shadow: none !important;
`;
export {
  c1 as default
};
//# sourceMappingURL=FilterPattern.js.map
